<template>
	<div id="app">
		<!--マップコンポーネント表示-->
		<!-- <header class="d-none"> -->
		<header>
		</header>
		<main style="height:100%;">
			<div class="parent">
				<!--
				<div class="child1" v-if="showDoubleScreen">
					<MapPane	ref="map" v-model="mapData" tagname="div" :screenmode="doublescreen" @changeShindoEkijyouka="changeLeftShindoEkijyouka"></MapPane>
				</div>
				<div class="child3" v-else>
				-->
				<div class="child3">
					<MapPane	ref="map" v-model="mapData" tagname="div" :screenmode="singlescreen" @changeShindoEkijyouka="changeLeftShindoEkijyouka"></MapPane>
				</div>
				<!--
				<div class="child2" v-if="showDoubleScreen">
					<MapPane	ref="mapsub" v-model="mapData2" tagname="div" :screenmode="rightscreen" @changeShindoEkijyouka="changeRightShindoEkijyouka"></MapPane>
				</div>
				-->
			</div>
 
			<!-- 市町村と縮尺表示 -->
			<div id="info" class="text-left" style="position: absolute; font-size: 12px; top: 6px; left: 6px; padding: 5px; background-color: rgba(255,255,255,1);">
				<span id="cityName">{{mapData.cityName}}</span><br>縮尺：約 1/<span id="scaleDenom">{{mapData.scaleValue}}</span>
			</div>
			<!--検索コントロール-->
			<div id="info" class="text-left" @click="showAddressChange" style="position: absolute; font-size: 12px; top: 5px; right: 5px; padding: 5px; background: rgba(0,0,0,0.0);">
				<img src="/image/search.png" alt="">
			</div>

			<!--左レイヤーメニュー　メニュー内のチェックボックスの状態を保持する為　v-show-->
			<!--ドロアーメニュー-->
			<div id="info" class="text-left" style="position: absolute; font-size: 12px; top: 50%; left: 5px; padding: 0px; background-color: rgba(255,255,255,1);">
				<button @click="toggleDrawer" class="btn btn-info">>></button>
				<div v-show="openDrawer">
					<Drawer	ref="draweMenu" @close="toggleDrawer" align="left" :closeable="false" :mask="false">
						<div v-show="openDrawer">
							<div style="padding: 15px;width:320px;">
								<div v-show="showLeftLayerMenu">
									<LayerMobileMenu ref="leftLayerMenu" :layerMenuPos="llayerMenuPos" v-bind:val="showLeftLayerMenu" v-on:closeLayerMenuNotify="toggleShowLeftLayerMenu" v-on:closeAllLayerMenuNotify="toggleShowLeftAllLayerMenu" @checkedLayer="dispatchShowLeftLayer" @saveCheckedLayers="saveSelectLayers"	@saveCheckedBaseLayers="saveSelectBaseLayers" @notifyMobileMenuMounted="notifyMobileMenuMounted" @shindoMenuLayer="shindoMenuLeftLayer" @ekijyoukaMenuLayer="ekijyoukaMenuLeftLayer"></LayerMobileMenu>
								</div>
							</div> 
						</div>
					</Drawer>
				</div>
			</div>
			
			<!-- 住所検索用（初期は非表示） -->
			<div id="mapaichidummy" style="display:none;"></div>
			<div id="addrdiv" style="width:300px; visibility:hidden;">
				<div id="addrdivheader" style="position:relative;">
					<div style="position:absolute; right:3px; top:3px;">
						<img id="addrClose" src="/image/round_highlight_off_white_36dp.png" style="width:20px;"
							onClick="dojo.doc.getElementById('addrdiv').style.visibility='hidden'"/>
					</div>
				</div>
				<div id="addresslandmark"></div>
			</div>
		</main>
		<!-- Footer -->
	</div>
</template>

<script>
// アコーディオンメニュー
import Vue from 'vue'
// import {SlideUpDown} from 'vue-slide-up-down'
import MapPane from './components/MapPane.vue'
import LayerMenu from './components/LayerMenu.vue'
import LayerMobileMenu from './components/LayerMobileMenu.vue'
import OtherMenu from './components/OtherMenu.vue'
import ScenarioSelectJishin from './components/ScenarioSelectJishin.vue'
import ScenarioSelectTsunami from './components/ScenarioSelectTsunami.vue'
import Drawer from "vue-simple-drawer";


const store = { 
		state:{ 
			showLeftLayerMenu: false 
		}, 
		changeshowLeftLayerMenu(){ 
		 this.state.showLeftLayerMenu = !this.state.showLeftLayerMenu		
		} 
}

export default {
	name: 'app',
	components: {
		// 'slide-up-down': SlideUpDown,
		LayerMenu,
		LayerMobileMenu,
		OtherMenu,
		MapPane,
		ScenarioSelectJishin,
		ScenarioSelectTsunami,
		Drawer,
	},	
	data () {
		return {

			showLeftLayerMenu: true,
			showRightLayerMenu: true,
			showOtherMenu: false,
			showDoubleScreen: false,
			isInterlocking: false,
			rbtDoubleScreen: "OFF",
			rbtInterlocking: "OFF",
			rlayer_button: "",
			llayer_button: "",
			rlayerMenuPos: "right",
			llayerMenuPos: "left",
			cityName: "住所取得中・・・",
			mode:"", // 1:シナリオ2 自由地震:3 自由津波
			freeFlg:false,
			mapData: {
				lon:0.0,
				lat:0.0,
				lonValue: "緯度 =						",
				latValue: "経度 =						",
				scaleValue: "",
				zoomValue: 11,
				cityName: "",
				comment_q: "",
				time: "",
				time30: "",
				depth: "",
				si: "",
				pl: "",
				height: "",
				layerMenuPos: "single",
				dicBaseLayers:"",
				dicLayers:"",
				kenFlg:true
			},
			/*
			mapData2: {
				lon:0.0,
				lat:0.0,
				lonValue: "緯度 =						",
				latValue: "経度 =						",
				scaleValue: "",
				zoomValue: 11,
				cityName: "",
				comment_q: "",
				time: "",
				time30: "",
				depth: "",
				si: "",
				pl: "",
				height: "",
				layerMenuPos: "left",
				dicBaseLayers:"",
				dicLayers:"",
				kenFlg:true
			},
			*/
			dicBaseLayers:{},
			dicLayers:{},
			//showMapSub:false,
			singlescreen:'singlescreen',
			doublescreen:'doublescreen',
			rightscreen:'rightscreen',

			shindoLeftLayer: 'L102',
			ekijyoukaLeftLayer: 'L112',
			shindoRighttLayer: 'L102',
			ekijyoukaRightLayer: 'L112',

			openDrawer:false,
			showLeftLayerMenu: false,
			llayerMenuPos: "left",
			saveLayers:[], //選択済みレイヤー
			saveBaseLayers:"L001", //選択済みレイヤー
			
			map:null,		//MyMapOPオブジェクト生成用
			add:false,		//住所から検索モードパラメータ
		}
	},
	mounted: function() {
		//URLクエリーから自由選択画面か否かを取得
		if ((this.$route.query.mode==='1')||(this.$route.query.mode==='2')||(this.$route.query.mode==='3')){
			this.mode=this.$route.query.mode;
		}else{
			this.mode='1';
		}
		
		//住所検索初期化
		this.map = new MyMapOP.MyMap('mapaichidummy');
		this.setAddress();
		
		//住所から検索モード時は住所ダイアログを表示
		if(this.add){
			this.showAddressChange();
		}
	},
	watch: {
			'mapData.kenFlg': function () {
				this.$refs.leftLayerMenu.dispKenRadio(this.mapData.kenFlg);
			},
			'mapData2.kenFlg': function () {
				this.$refs.rightLayerMenu.dispKenRadio(this.mapData2.kenFlg);
			},

			//地図コンポーネントよりレイヤー一覧の全タイトル文字列を取得
			'mapData.dicLayers': function () {
				this.dicBaseLayers = JSON.parse(this.mapData.dicBaseLayers);
				this.dicLayers = JSON.parse(this.mapData.dicLayers);
				console.log('監視：'+this.dicLayers['L101'])
				console.log('監視：'+this.dicBaseLayers)
				// this.$refs.leftLayerMenu.setLayers(this.mapData.dicBaseLayers,this.mapData.dicLayers);
				// this.$refs.leftLayerMenu.setLayers(this.mapData.dicBaseLayers,this.mapData.dicLayers,this.saveLayers,this.saveBaseLayers);
			},
			/*
			'mapData2.dicLayers': function () {
				this.dicBaseLayers = JSON.parse(this.mapData.dicBaseLayers);
				this.dicLayers = JSON.parse(this.mapData.dicLayers);
				console.log('監視：'+this.dicLayers['L101'])
				console.log('監視：'+this.dicBaseLayers)
				// this.$refs.rightLayerMenu.setLayers(this.mapData.dicBaseLayers,this.mapData.dicLayers);
				// this.$refs.rightLayerMenu.setLayers(this.mapData.dicBaseLayers,this.mapData.dicLayers,this.saveLayers,this.saveBaseLayers);
			},
			*/
			//地図の緯度経度の変更を監視する 
			//左地図
			'mapData.lon': function () {
				if ((this.showDoubleScreen)&&(this.isInterlocking)){
					console.log('監視：'+this.mapData.lon)
					//this.$refs.mapsub.centerMove(this.mapData.lon,this.mapData.lat);
				}
			},
			'mapData.lat': function () {
				if ((this.showDoubleScreen)&&(this.isInterlocking)){
					console.log('監視：'+this.mapData.lat)
					//this.$refs.mapsub.centerMove(this.mapData.lon,this.mapData.lat);
				}
			},
			'mapData.zoomValue': function () {
				console.log('監視：'+this.mapData.zoomValue)
				//this.$refs.mapsub.setZoom(this.mapData.zoomValue);
			},
			//右地図 
			/*
			'mapData2.lon': function () {
				if ((this.showDoubleScreen)&&(this.isInterlocking)){
					console.log('監視2：'+this.mapData2.lon)
					this.$refs.map.centerMove(this.mapData2.lon,this.mapData2.lat);
				}
			},
			'mapData2.lat': function () {
				if ((this.showDoubleScreen)&&(this.isInterlocking)){
					console.log('監視2：'+this.mapData2.lat)
					this.$refs.map.centerMove(this.mapData2.lon,this.mapData2.lat);
				}
			},
			'mapData2.zoomValue': function () {
				console.log('監視：'+this.mapData2.zoomValue)
				this.$refs.map.setZoom(this.mapData2.zoomValue);
			},
			*/
	},


	methods: {
		toggleDrawer() {
			this.openDrawer = !this.openDrawer
			this.showLeftLayerMenu = !this.showLeftLayerMenu;
			console.log('toggleDrawer!!:'+this.openDrawer);
		},		
		//レイヤメニュー表示切り替え
		toggleShowLeftLayerMenu() {
			console.log('app toggleShowLeftLayerMenu!!');
			this.openDrawer = !this.openDrawer
			this.showLeftLayerMenu = !this.showLeftLayerMenu;
			console.log('toggleShowLeftLayerMenu!!:'+this.openDrawer);
		},
		//レイヤーメニューより選択したレイヤーのセーブを行う（レイヤーメニューからcall）
		saveSelectLayers(eventArgs){
			console.debug('親APPにレイヤ保存!!');
			this.saveLayers = eventArgs.value;
		},
		//レイヤーメニューより選択したレイヤーのセーブを行う（レイヤーメニューからcall）
		saveSelectBaseLayers(eventArgs){
			console.debug('親APPにレイヤ保存!!');
			this.saveBaseLayers = eventArgs.value;
		},
		//レイヤーメニューよりマウント完了時通知を受ける(レイヤーメニューからcall)
		notifyMobileMenuMounted: function(){
			//draweメニューが開いているとき
			if (this.openDrawer){
				console.debug(this.mapData.dicLayers);
				console.debug(this.saveBaseLayers);
				//タイトル表示用のレイヤーをモバイルレイヤーメニューに通知
				this.$refs.leftLayerMenu.setLayers(this.mapData.dicBaseLayers,this.mapData.dicLayers,this.saveLayers,this.saveBaseLayers);
			}
		},


		changeLeftShindoEkijyouka: function(eventArgs){
			console.debug('changeLeftShindoEkijyouka shindo!!!!!!!!!' + eventArgs.shindo);
			console.debug('changeLeftShindoEkijyouka ekijyouka!!!!!!!!!' + eventArgs.ekijyouka);
			if (eventArgs.shindo !== ''){
				this.$refs.leftLayerMenu.ForcechangeLayer(eventArgs.shindo);
			}
			if (eventArgs.ekijyouka !== ''){
				this.$refs.leftLayerMenu.ForcechangeLayer(eventArgs.ekijyouka);
			}
		},
		changeRightShindoEkijyouka: function(eventArgs){
			console.debug('changeRightShindoEkijyouka shindo!!!!!!!!!' + eventArgs.shindo);
			console.debug('changeRightShindoEkijyouka ekijyouka!!!!!!!!!' + eventArgs.ekijyouka);
			if (eventArgs.shindo !== ''){
				this.$refs.RightLayerMenu.ForcechangeLayer(eventArgs.shindo);
			}
			if (eventArgs.ekijyouka !== ''){
				this.$refs.RightLayerMenu.ForcechangeLayer(eventArgs.ekijyouka);
			}
		},



		toggleShowLeftAllLayerMenu: function(){
			//レイヤー一覧に通知
			this.$refs.leftLayerMenu.toggleShowLeftAllLayerMenu();
		},
		toggleShowRightAllLayerMenu: function(){
			//レイヤー一覧に通知
			this.$refs.rightLayerMenu.toggleShowRightAllLayerMenu();
		},
		// handlerMap(value){
		//		 console.debug('mounted value.dicLayers:'+ value.dicLayers);
		//		 // console.debug('mounted value.lon:'+ value.lon);
		//		 // this.mapData=value;
		// },
		// handlerMap2(value){
		//		 console.debug('mounted value.dicLayers:'+ value.dicLayers);
		//		 // this.mapData2=value;
		// },
		//レイヤメニュー表示切り替え
		// toggleShowLeftLayerMenu() {
		// 	console.log('app toggleShowLeftLayerMenu!!');
			// this.showLeftLayerMenu = !this.showLeftLayerMenu;
			// if (!this.showLeftLayerMenu){
			//	 this.llayer_button = "＋";
			// }else{
			//	 this.llayer_button = "";
			// }
		// },
		toggleShowRightLayerMenu() {
			console.log('app toggleShowRightLayerMenu!!');
			// this.showRightLayerMenu = !this.showRightLayerMenu;
			// if (!this.showRightLayerMenu){
			//	 this.rlayer_button = "＋";
			// }else{
			//	 this.rlayer_button = "";
			// }
		},
		//その他メニュー表示切り替え
		toggleShowOtherMenu() {
			this.showOtherMenu = !this.showOtherMenu;
		},
		//レイヤ選択イベント
		layerSelectEvent: function(val){
			alert('親がイベントを受け取った'+val);
		},
		//左地図画面へレイヤ表示非表示をデイスパチ
		dispatchShowLeftLayer(eventArgs){
			console.log('デイスパチmap value:'+eventArgs.value);
			console.log('デイスパチmap checkedLayers:'+eventArgs.checkedLayers);
			console.log('デイスパチmap checkedAllLayers:'+eventArgs.checkedAllLayers);
			// this.$refs.map.showLayer(eventArgs.value,eventArgs.display);
			this.$refs.map.showLayer(eventArgs);
			console.log('デイスパチmap end');
		},
		//震度と液状化の市、県ラジオボタンの値 LayerMenu=>App=>Mapへ通知
		shindoMenuLeftLayer(eventArgs){
			console.log('shindoMenuLeftLayer start:'+eventArgs.Layer);
			this.shindoLeftLayer= eventArgs.Layer;
			this.$refs.map.shindoMenuLayer(this.shindoLeftLayer);
		},
		ekijyoukaMenuLeftLayer(eventArgs){
			console.log('ekijyoukaMenuLeftLayer start:'+eventArgs.Layer);
			this.ekijyoukaLeftLayer= eventArgs.Layer;
			this.$refs.map.ekijyoukaMenuLayer(this.ekijyoukaLeftLayer);
		},
		shindoMenuRightLayer(eventArgs){
			console.log('shindoMenuRightLayer start:'+eventArgs.Layer);
			this.shindoRighttLayer= eventArgs.Layer;
			this.$refs.mapsub.shindoMenuLayer(this.shindoRighttLayer);
		},
		ekijyoukaMenuRightLayer(eventArgs){
			console.log('ekijyoukaMenuRightLayer start:'+eventArgs.Layer);
			this.ekijyoukaRightLayer= eventArgs.Layer;
			this.$refs.mapsub.ekijyoukaMenuLayer(this.ekijyoukaRightLayer);
		},


		/*
		//右地図画面へレイヤ表示非表示をデイスパチ
		dispatchShowRightLayer(eventArgs){
			console.log('デイスパチmapsub start:'+eventArgs.value);
			console.log('デイスパチmapsub checkedLayers:'+eventArgs.checkedLayers);
			console.log('デイスパチmapsub checkedAllLayers:'+eventArgs.checkedAllLayers);
			// this.$refs.mapsub.showLayer(eventArgs.value,eventArgs.display);
			this.$refs.mapsub.showLayer(eventArgs);
			console.log('デイスパチmapsub end');
		},
		//子からの2画面切り替え 
		changeDoubleScreen(rbtDoubleScreen){
			if (this.rbtDoubleScreen !=rbtDoubleScreen){
				this.rbtDoubleScreen =rbtDoubleScreen;
				this.onChange_rbtDoubleScreen();
			}
		},
		//2画面切り替え			
		onChange_rbtDoubleScreen() {
			this.$refs.map.toggleDoubleScreen();
			if (this.rbtDoubleScreen == "OFF"){
				//1画面表示にする
				this.showDoubleScreen = false;
				this.mapData.layerMenuPos = "single";

				this.rbtInterlocking = "OFF";
				this.isInterlocking = false;
				this.$forceUpdate();
			}else{
				//2画面表示にする
				this.showDoubleScreen = true;
				this.mapData.layerMenuPos = "double";
				this.mapData2.layerMenuPos = "right";
				this.rbtInterlocking = "OFF";
				this.isInterlocking = false;
				//左画面の中心座標を右画面にセット
				this.mapData2.lon = this.mapData.lon;
				this.mapData2.lat = this.mapData.lat;
				this.mapData2.lonValue = this.mapData.lonValue;
				this.mapData2.latValue = this.mapData.latValue;
				this.mapData2.scaleValue = this.mapData.scaleValue;
				this.mapData2.cityName = this.mapData.cityName;
				this.mapData2.comment_q = this.mapData.comment_q;
				this.mapData2.time = this.mapData.time;
				this.mapData2.time30 = this.mapData.time30;
				this.mapData2.depth = this.mapData.depth;
				this.mapData2.si = this.mapData.si;
				this.mapData2.pl = this.mapData.pl;
				this.mapData2.height = this.mapData.height;
				this.mapData2.layerMenuPos = "right";
				this.$forceUpdate();

			}
		},			
		//子からの２画面連動
		changeInterlocking(rbtInterlocking){
			if (this.rbtInterlocking != rbtInterlocking){
				this.rbtInterlocking = rbtInterlocking;
				this.onChange_rbtInterlocking();
			}
		},
		//２画面連動
		onChange_rbtInterlocking() {
			if (this.rbtInterlocking == "OFF"){
				this.isInterlocking = false;
				this.rbtInterlocking = "OFF";
			}else{
				this.isInterlocking = true;
				this.rbtInterlocking = "ON";
			}
		},
		*/
		//住所検索領域初期化
		setAddress: function() {
			//dijitの読込に時間がかかるので3秒待つ
			console.log("setAddress start");
			
			//setTimeout以下は関数になってthisが使えなくなるので、thisの必要な変数をここで受け渡しておく
			var mapOP = this.map;
			var refs = this.$refs;
			var setZoom = this.setZoom;

			setTimeout(function() {
				dojo.body().className = "nihilo";
				//dojo.doc.getElementById("addrdiv").style.display = "";
				var dialog = new dijit.layout.ContentPane({"title":"", "id":"movable"});
				var tab = new dijit.layout.TabContainer({"id":"tab", "style":"width:500px; height:500px;"});
				dialog.addChild(tab);
				var addresspane = new dijit.layout.BorderContainer({"id":"address", "title":"住所検索"});
				tab.addChild(addresspane);
				//var landmarkpane = new dijit.layout.BorderContainer({"id":"landmark", "title":"目標物検索"});
				//tab.addChild(landmarkpane);
				dialog.placeAt(dojo.doc.getElementById("addresslandmark"));
				dialog.startup();

				mapOP._addr.listAddressSelect = function(level, evt) {
					var target = evt.target;
					if (MyMapOP.Util.isEmpty(target) || target.tagName != "A") {
						return;
					}
					var id = target.id;
					if (!MyMapOP.Util.isZeroLength(id)) {
						var ids = id.split("_");
						if (ids.length == 3) {
							console.log("level:"+level+" , "+[parseFloat(ids[1]),parseFloat(ids[2])]);
							//地図移動
							refs.map.centerMove(parseFloat(ids[2]), parseFloat(ids[1]));
							setZoom(level);
						}
					}
					if (MyMapOP.Util.isNumeric(level)) {
						// reset
						for (var l=level+1; l<=5; l++) {
							MyMapOP.Layout.listAddressPane[l].set("disabled", true);
							MyMapOP.Layout.resetListAddressPane(l);
						}
						
						MyMapOP.Address.listAddress(level, target.innerHTML);
						MyMapOP.Layout.changeListAddressPane(level);
					}
				};

				mapOP._layout.createListAddressContainer("address");
				mapOP._addr.listAddress(1);
				//mapOP._layout.createListLandmarkContainer("landmark");
				//mapOP._land.listLandmarkCode();

				dragElement(dojo.doc.getElementById("addrdiv"));
			}, 3*1000);
		},
		//住所レベルに応じた縮尺変更
		setZoom: function(level){
			var nowZoom = this.mapData.zoomValue;
			console.log("now Zoom : "+nowZoom);
			switch(level){
			case 2://市町村
				if(nowZoom <= 11){this.$refs.map.setZoom("12");}
				break;
			case  3://大字
				if(nowZoom <= 13){this.$refs.map.setZoom("14");}
				break;
			case 4://小字
				if(nowZoom <= 14){this.$refs.map.setZoom("15");}
				break;
			case 5://番地
				if(nowZoom <= 15){this.$refs.map.setZoom("16");}
				break;
			case null://号
				if(nowZoom <= 16){this.$refs.map.setZoom("17");}
				break;
			default:
				break;
			}
		},
		//住所検索領域表示/非表示切替
		showAddressChange: function() {
			if(dojo.doc.getElementById("addrdiv").style.visibility == "hidden"){
				dojo.doc.getElementById("addrdiv").style.visibility = "visible";
				console.log("addrdiv : disp");
			}else{
				dojo.doc.getElementById("addrdiv").style.visibility = "hidden";
				console.log("addrdiv : none");
			}
		},
	}

}
</script>


<style>
@import "/css/App.css";
@import "/css/nihilo.css";
@import "/css/selectarea.css";
</style>

